export enum MediaFieldMenuState {
  UPLOAD = 'UPLOAD',
  EMBED = 'EMBED',
  LIBRARY = 'LIBRARY',
}
